// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".auth-register[data-v-9defc1ae]{display:flex;flex:1}.auth-register .exc-checkbox[data-v-9defc1ae]{padding-left:1.875rem;line-height:1.125rem}.auth-register__have-an-account[data-v-9defc1ae]{display:flex}.tdx-base-input[data-v-9defc1ae]{padding:0 35.5px 0 11.5px;line-height:30px}[data-v-9defc1ae] .exc-checkbox label:before{top:10px!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
